import { DonationType } from "@nkr/enums/donation-type";

export interface IConvertDonationType {
    donationType: DonationType,
    donationDate: string
}